module.exports = __webpack_public_path__ + "img/icon_chocomint@3x.005b9082.png";